const initialState = {
  loginProcess: "domain",
  login: false,
  menu: "",
  ctiType: "zendesk",
  TicketFieldModal: false,
  TestTicketModal: false,
  LoadingTicketField: false,
  SettingModal: false,
};

const ReduxState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    default:
      return state;
  }
};
export default ReduxState;
